"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return undefined;
};
//# sourceMappingURL=gauge.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/xAxis/gauge.js
 ** module id = 207
 ** module chunks = 0 1
 **/